import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseAddMutation, IAddFn, IGetPostRequest, ITrainingEvent, ITrainingEventUpsert } from '../../interfaces'

const getAddTrainingEventMutationRequest: IGetPostRequest = params => {
  return {
    method: 'post',
    url: `${config.baseUrl}/TrainingEvents`,
  }
}

const useAddTrainingEventMutation: IUseAddMutation<ITrainingEvent, ITrainingEventUpsert> = (params, options = {}) => {
  const request = useMemo(() => getAddTrainingEventMutationRequest(params), [params])

  const addTraining: IAddFn<ITrainingEventUpsert, ITrainingEvent> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingEvent, Error, any>({
    mutationFn: addTraining,
    ...options,
  })

  return response
}

export default useAddTrainingEventMutation
